import { Component, OnInit } from '@angular/core';
import { App } from "ionic-angular";

import { IonicPage, NavController, AlertController, ViewController, NavParams, PopoverController, LoadingController, ModalController } from 'ionic-angular';
import { Users, Activities, Updates} from 'api/collections';
import { User, Activity, Update } from 'api/models';
import { MeteorObservable } from 'meteor-rxjs';
import * as _ from 'lodash';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
// import { getProject } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
import { CalendarComponent, CalendarModal, CalendarComponentOptions } from 'ion2-calendar';
import { AugmentedActivity, ActivityService } from '../../services/activityData';
import { ActivityMenuComponent } from '../../components/activity-menu/activity-menu';
import * as moment from 'moment';
import { HttpService } from '../../services/httpService';
import { ISDEV, APP_TITLE } from "../../services/config";
import { SharedService } from '../../services/sharedService';

import {
  getDayVsScheduledStart,
  getDurationDelta,
  getFinishDelta,
  getStartDelta,
  daysBetween,
  getRemainingDurationInProgressProjectedFinish,
  getRemainingDurationInProgressFinishDelta,
  getRemainingDurationInProgressProjectedDuration,
  getRemainingDurationInProgressDurationDelta,
  getPercentCompleteInProgressProjectedFinish,
  getPercentCompleteInProgressFinishDelta,
  getPercentCompleteInProgressProjectedDuration,
  getPercentCompleteInProgressDurationDelta,
  getDayVsScheduledEnd,
  calculateProjectedFinish,
  calculateProjectedDuration,
} from '../../services/p6calendar';
import { Http } from '@angular/http';

@IonicPage()
@Component({
  selector: 'page-activity-details',
  templateUrl: 'activity-details.html',
})
export class ActivityDetailsPage implements OnInit {
  public isDev = ISDEV;
  activity: AugmentedActivity | void;
  prevActivity: AugmentedActivity | void;
  percentComplete: number;
  remainingDuration: number;
  newStartDate: string;
  newFinishDate: string;
  update: Update;
  selectedUpdate: Update | void;
  workDays: any;
  exceptionDays: any;
  day: Date;
  getDayVsScheduledStart: number;
  getDurationDelta: number;
  getFinishDelta: number;
  getStartDelta: number;
  getRemainingDurationInProgressProjectedFinish: number;
  getRemainingDurationInProgressFinishDelta: number;
  getRemainingDurationInProgressProjectedDuration: number;
  getRemainingDurationInProgressDurationDelta: number;
  getPercentCompleteInProgressProjectedFinish: number;
  getPercentCompleteInProgressFinishDelta: number;
  getPercentCompleteInProgressProjectedDuration: number;
  getPercentCompleteInProgressDurationDelta: number;
  getDayVsScheduledEnd: number;
  calculateProjectedFinish: number;
  calculateProjectedDuration: number;
  baselineRemainingDuration: number;
  hrCount: number;
  projectedDuration: number;
  baseline


  constructor(
    private _app: App,
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public navParams: NavParams,
    private viewCtrl: ViewController,
    private modalCtrl: ModalController,
    public httpService: HttpService,
    private sharedService: SharedService,
    private activityService: ActivityService,

    public projectService: ProjectService
    ) {}
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }

  ngOnInit() {

    const activityId = < string > this.navParams.get('activityId');
    const updateId = < string > this.navParams.get('updateId');
    let myDate = new Date()
    var tzo = (myDate.getTimezoneOffset() / 60) * (-1);
    myDate.setHours(myDate.getHours() + tzo)
    this.day = myDate;
    MeteorObservable.autorun().subscribe({
      next: () => {
        // MeteorObservable.subscribe('activityListForUpdateId', updateId).subscribe();
        this.httpService.MeteorSubscribe('activityListForUpdateId', updateId);
        this.update = Updates.findOne(updateId);

        // new
        this.httpService.MeteorCall("getActivity",activityId)
          .then((res: any) => {
            if(this.isDev == true) { console.log("finding activity ", activityId, res) }
            this.activity = res ? this.activityService.getAugmentedActivity(res) : null;
            // MeteorObservable.subscribe('activityListForUpdateId', this.activity.updateId, undefined, activityId, 1).subscribe();
            this.httpService.MeteorSubscribe('activityListForUpdateId', this.activity.updateId, undefined, activityId, 1);
            this.update = Updates.findOne(this.activity.updateId);
            //TODO: for testing cnldr id error
            if(this.isDev == true) { console.log(this.activity); }
            // Attempt to fix see details error
            // let calendarId = this.activity.taskRow.clndr_id.toString(); // old
            let calendarId = this.activity.taskRow.clndr_id; // new
            if(this.isDev == true) { console.log(this.update) }
            this.workDays = this.update.calendars[calendarId].workDays;
            this.exceptionDays = this.update.calendars[calendarId].exceptionDays;
            if(this.isDev == true) { console.log("work days", this.workDays) }
            if(this.isDev == true) { console.log("exception days", this.exceptionDays) }
            // pulls the hour count from one of the schedules based off the calendarID
            this.hrCount = this.update.calendars[calendarId].dayHrs;
            if(this.isDev == true) {
              console.log("looking at update", this.update)
              console.log("looking at activity", this.activity)
              console.log("Workdays and Exception Days: " + this.workDays + " and " + this.exceptionDays)
            }
            // Nico Claculations
            //TODO: implement this function later, after p6 clandar file is changed to typescript
            //Temporary calculation for the baseline remaining duration
            this.baselineRemainingDuration = (this.activity.taskRow.remain_drtn_hr_cnt / this.hrCount);
            //Temporary value for percent complete -- assuming that the progressAmount value
            // from p6 is the correct value for percentComplete
            this.percentComplete = Math.round(Math.round(100 * (1 - (this.activity.taskRow.remain_drtn_hr_cnt / this.activity.taskRow.target_drtn_hr_cnt))) / 5) * 5;
            //tests
            if(this.isDev == true) {
              console.log('activity remaining duration: ' + this.activity.remainingDuration);
              console.log('Hour Count: ' + this.hrCount);
              console.log('Baseline Remaining Duration: ' + this.baselineRemainingDuration);
              console.log('Projected Finish: ' + this.getRemainingDurationInProgressProjectedFinish);
            }
            try { this.getDayVsScheduledStart = getDayVsScheduledStart(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getDurationDelta = getDurationDelta(this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getStartDelta = getStartDelta(this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getFinishDelta = getFinishDelta(this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getRemainingDurationInProgressProjectedFinish = getRemainingDurationInProgressProjectedFinish(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getRemainingDurationInProgressFinishDelta = getRemainingDurationInProgressFinishDelta(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getRemainingDurationInProgressProjectedDuration = getRemainingDurationInProgressProjectedDuration(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getRemainingDurationInProgressDurationDelta = getRemainingDurationInProgressDurationDelta(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getPercentCompleteInProgressProjectedFinish = getPercentCompleteInProgressProjectedFinish(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getPercentCompleteInProgressFinishDelta = getPercentCompleteInProgressFinishDelta(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getPercentCompleteInProgressProjectedDuration = getPercentCompleteInProgressProjectedDuration(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getPercentCompleteInProgressDurationDelta = getPercentCompleteInProgressDurationDelta(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getDayVsScheduledEnd = getDayVsScheduledEnd(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
          })
          .catch((e: Error) => {
            this.handleError(e);
          });
        }
        /*
        // old
        MeteorObservable.call("getActivity",
          activityId
        ).subscribe({
          next: (res: any) => {
            if(this.isDev == true) { console.log("finding activity ", activityId, res) }
            this.activity = res ? getAugmentedActivity(res) : null;
            // MeteorObservable.subscribe('activityListForUpdateId', this.activity.updateId, undefined, activityId, 1).subscribe();
            this.httpService.MeteorSubscribe('activityListForUpdateId', this.activity.updateId, undefined, activityId, 1);
            this.update = Updates.findOne(this.activity.updateId);
            //TODO: for testing cnldr id error
            if(this.isDev == true) { console.log(this.activity); }
            // Attempt to fix see details error
            // let calendarId = this.activity.taskRow.clndr_id.toString(); // old
            let calendarId = this.activity.taskRow.clndr_id; // new
            if(this.isDev == true) { console.log(this.update) }
            this.workDays = this.update.calendars[calendarId].workDays;
            this.exceptionDays = this.update.calendars[calendarId].exceptionDays;
            if(this.isDev == true) { console.log("work days", this.workDays) }
            if(this.isDev == true) { console.log("exception days", this.exceptionDays) }
            // pulls the hour count from one of the schedules based off the calendarID
            this.hrCount = this.update.calendars[calendarId].dayHrs;
            if(this.isDev == true) {
              console.log("looking at update", this.update)
              console.log("looking at activity", this.activity)
              console.log("Workdays and Exception Days: " + this.workDays + " and " + this.exceptionDays)
            }
            // Nico Claculations
            //TODO: implement this function later, after p6 clandar file is changed to typescript
            //Temporary calculation for the baseline remaining duration
            this.baselineRemainingDuration = (this.activity.taskRow.remain_drtn_hr_cnt / this.hrCount);
            //Temporary value for percent complete -- assuming that the progressAmount value
            // from p6 is the correct value for percentComplete
            this.percentComplete = Math.round(Math.round(100 * (1 - (this.activity.taskRow.remain_drtn_hr_cnt / this.activity.taskRow.target_drtn_hr_cnt))) / 5) * 5;
            //tests
            if(this.isDev == true) {
              console.log('activity remaining duration: ' + this.activity.remainingDuration);
              console.log('Hour Count: ' + this.hrCount);
              console.log('Baseline Remaining Duration: ' + this.baselineRemainingDuration);
              console.log('Projected Finish: ' + this.getRemainingDurationInProgressProjectedFinish);
            }
            try { this.getDayVsScheduledStart = getDayVsScheduledStart(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getDurationDelta = getDurationDelta(this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getStartDelta = getStartDelta(this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getFinishDelta = getFinishDelta(this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getRemainingDurationInProgressProjectedFinish = getRemainingDurationInProgressProjectedFinish(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getRemainingDurationInProgressFinishDelta = getRemainingDurationInProgressFinishDelta(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getRemainingDurationInProgressProjectedDuration = getRemainingDurationInProgressProjectedDuration(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getRemainingDurationInProgressDurationDelta = getRemainingDurationInProgressDurationDelta(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getPercentCompleteInProgressProjectedFinish = getPercentCompleteInProgressProjectedFinish(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getPercentCompleteInProgressFinishDelta = getPercentCompleteInProgressFinishDelta(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getPercentCompleteInProgressProjectedDuration = getPercentCompleteInProgressProjectedDuration(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getPercentCompleteInProgressDurationDelta = getPercentCompleteInProgressDurationDelta(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
            try { this.getDayVsScheduledEnd = getDayVsScheduledEnd(this.day, this.activity, this.workDays, this.exceptionDays) } catch (err) {}
          }
        })
      },
      error: (e: Error) => {
        this.handleError(e);
      }
    });
    */
    });
  }

  isFinishMilestone(activity) {
    return activity.taskType === 'TT_FinMile';
  }

  absoluteValue(num) {
    return Math.abs(num).toFixed(0);
  }

  isStartMilestone(activity) {
    return activity.taskType === 'TT_Mile';
  }

  earlyStart(activity) {
    return moment(activity.actualStart || activity.earlyStart).unix();
  }

  earlyFinish(activity) {
    return moment(activity.actualFinish || activity.earlyFinish).unix();
  }
  totalFloat(activity) {
    return activity.totalFloat;
  }

  lateness(activity) {
    return -1 * activity.daysLate;
  }
  projectLateness(activity) {
    return -1 * (activity.blFinishDelta + activity.totalFloat);
  }

  blStartDeltaMom(activity) {
    if(this.isDev == true) { console.log("moment(activity.actualStart).add(activity.blStartDelta, 'd').unix()") }
  }

  goToProgress(activity: AugmentedActivity): void {

    const modal = this.modalCtrl.create(ActivityMenuComponent, { activity: this.activity }, { enableBackdropDismiss: false });
    modal.present();

  }

  ionViewDidLoad() {
    if(this.isDev == true) { console.log('ionViewDidLoad ActivityDetailsPage') }
  }


  onChange(ev: any) {
    if(this.isDev == true) { console.log('Changed', ev) }
  }

  handleError(e: Error): void {
    if(this.isDev == true) { console.error(e) }

  }


}



// WEBPACK FOOTER //
// ./src/pages/activity-details/activity-details.ts